import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../core/services';
import {Router} from '@angular/router';
import {UserModel} from '../../../core/models';

@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.css']
})
export class ProfileAvatarComponent implements OnInit {
  currentUser: UserModel;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    );
  }


  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }

}
